import { render, staticRenderFns } from "./master-item.vue?vue&type=template&id=4a352c49&scoped=true"
import script from "./master-item.vue?vue&type=script&lang=js"
export * from "./master-item.vue?vue&type=script&lang=js"
import style0 from "./master-item.vue?vue&type=style&index=0&id=4a352c49&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a352c49",
  null
  
)

export default component.exports